import { render, staticRenderFns } from "./CreateNewsletterDrawer.vue?vue&type=template&id=a804dcbc&scoped=true&lang=pug&"
import script from "./CreateNewsletterDrawer.vue?vue&type=script&lang=js&"
export * from "./CreateNewsletterDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewsletterDrawer.vue?vue&type=style&index=0&id=a804dcbc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a804dcbc",
  null
  
)

/* custom blocks */
import block0 from "./CreateNewsletterDrawer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports